/** A native select styled like the app's inputs. Native, because on a phone it opens the system picker. */
export const selectClass =
  'h-10 w-full rounded-md border border-gray-300 bg-white px-3 text-base text-heritage-blue-700 ' +
  'focus:border-heritage-blue-400 focus:outline-none focus:ring-2 focus:ring-heritage-blue-200 ' +
  'disabled:opacity-60 sm:text-sm aria-[invalid=true]:border-red-400'
